import { Sensor, SensorDetail } from '@/entities/sensor';

export function intoEditable(data: SensorDetail): Sensor {
  return {
    ...data.data,
    createIssueFor: data.data.createIssueFor ? data.data.createIssueFor.data : null,
    entityItem: data.data.entityItem?.id ?? null,
    alarmUsers: data.data.createIssueFor ? data.data.createIssueFor.data.users : [],
  };
}
